import { render, staticRenderFns } from "./shapes.vue?vue&type=template&id=e7c8b994&"
import script from "./shapes.vue?vue&type=script&lang=js&"
export * from "./shapes.vue?vue&type=script&lang=js&"
import style0 from "./shapes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports